import { Button } from 'react-bootstrap';
import styles from '../../../../styles/incidents.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMultiply, faPenToSquare, faPlus } from '@fortawesome/free-solid-svg-icons';
import ButtonOverride from '../../../../components/buttonoverride';

const IncidentNotificationsList = ({fields,toggleAdd,onEdit,notificationTypes = [],remove}) => {
    
    const _GetNotificationTo = (item) => {
        const to = item.reportedToOther
        ?   item.reportedToOther
        :   notificationTypes.find((notif) => notif.id === item.reportedTo)?.name || "N/A"

        const datetime = item.reportTime !== null ? _getDate(new Date(item.reportTime)) : 'N/A';

        return {to,datetime};

    }

    const _getDate = (dateString) => {
        if(dateString === null) return 'N/A';
        const dateOptions = {
            month: 'numeric',
            day: 'numeric',
            year: 'numeric',
          };
          const timeOptions = {
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: true,
          };
        
          const datePart = dateString.toLocaleDateString('en-US', dateOptions);
          const timePart = dateString.toLocaleTimeString('en-US', timeOptions);
        
          return `${datePart} ${timePart}`;
    }

    return(
        <>
            <div className={styles.notificationsHeader}>
                <h5 className='fw-bold me-1 mb-0'>
                    Notifications
                </h5>
                {
                    fields.length > 0
                    &&
                    <Button type='button' variant='success' size='sm' className={styles.addNotificationButton} aria-label='Add Notification' onClick={toggleAdd}>
                            <FontAwesomeIcon icon={faPlus} />
                    </Button>
                }
            </div>
            <div className={`${styles.notificationsBody} ${fields.length === 0 ? styles.start : null}`}>
                {
                    fields.length > 0
                    ?
                        <ul className={styles.notificationList}>
                            {
                                fields.map((item,index) => {
                                    const {to,datetime} = _GetNotificationTo(item);
                                    return(
                                        <li key={index} className={styles.notificationItem}>
                                            <div className={styles.notificationContent}>
                                                <div className='d-flex justify-content-between'>
                                                    <strong>{to}</strong>
                                                    <strong>{datetime}</strong>
                                                </div>
                                                <p className={styles.notificationText}>
                                                    {item.comments}
                                                </p>
                                                <div className='d-flex justify-content-end'>
                                                    <Button className='me-1' size='sm' type='button' variant='primary' onClick={() => onEdit(index)}>
                                                        <FontAwesomeIcon icon={faPenToSquare} />
                                                    </Button>
                                                </div>
                                            </div>
                                            <ButtonOverride type="button" className={styles.deleteAddedButton} aria-label="Remove Notification" title="Remove Notification" onClick={() => remove(index)} >
                                                <FontAwesomeIcon icon={faMultiply} size="lg" style={{color: 'red'}}/>
                                            </ButtonOverride>
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    :
                        <Button type='button' variant='success' className={styles.addNotificationButtonLg} aria-label='Add Notification' onClick={toggleAdd}>
                            <FontAwesomeIcon icon={faPlus} size='2xl'/>
                        </Button>
                }
            </div>
        </>
    )
}

export default IncidentNotificationsList;